@reference "@glow/tailwind-config/reference.css";

.button {
  @apply px-28;
  @apply py-6;
  @apply bg-primary-050;
  @apply text-primary-500;
  @apply border border-primary-500;
  @apply border-dashed;
  @apply rounded-lg;
  @apply flex;
  @apply flex-col;
  @apply items-center;
  @apply gap-2;
  @apply text-emphasis-medium;
  @apply bg-cover;
  @apply relative;
  @apply text-sm;
  @apply text-center;
}

.button.hasError {
  @apply bg-danger-light;
  @apply border border-danger-dark;
}

.button.disabled {
  @apply opacity-30;
}

.button.dragging {
  @apply bg-primary-100;
  @apply border-2;
}

.container {
  @apply flex;
  @apply gap-4;
  @apply md:block;
}

.button .title {
  @apply font-semibold;
  @apply mt-2;
}

.iconContainer {
  @apply bg-black/20;
  @apply pt-5;
  @apply w-full;
  @apply text-base;
  @apply text-white;
  @apply top-0;
  @apply left-0;
  @apply absolute;
  @apply h-full;
  @apply rounded-lg;
  @apply text-center;
}

.smallButton {
  @apply p-4;
  @apply h-16;
  @apply w-16;
  @apply gap-0;
}

.fileCardDesktop {
  @apply w-full;
  @apply h-16;
  @apply mt-4;
}
.fileCardDesktop .container {
  @apply grid;
  @apply grid-cols-[64px_240px_auto];
  @apply gap-4;
  @apply h-full;
}
.fileCardDesktop .content {
  @apply flex;
  @apply flex-col;
  @apply gap-1;
  @apply justify-center;
}

.fileCardDesktop img {
  @apply rounded-l-lg;
  @apply w-16;
  @apply h-16;
  @apply object-cover;
}
.fileCardDesktop .title {
  @apply font-semibold;
  @apply text-sm;
  @apply text-emphasis-high;
  @apply overflow-hidden;
  @apply text-ellipsis;
  @apply whitespace-nowrap;
}
.fileCardDesktop .description {
  @apply text-xs;
  @apply text-emphasis-medium;
}

.fileCardDesktop .buttonContainer {
  @apply flex;
  @apply justify-end;
  @apply pr-4;
  @apply text-base;
  @apply items-center;
}

.buttonContainer button {
  @apply hover:bg-gray-100;
  @apply w-8;
  @apply h-8;
  @apply rounded-sm;
}

.fileCardMobile {
  @apply w-16;
  @apply h-16;
  @apply relative;
  @apply rounded-lg;
}

.button input[type="file"] {
  @apply cursor-pointer;
  @apply z-10;
}
.button input[type="file"]:disabled {
  @apply cursor-not-allowed;
}

.button input[type="file"]:disabled {
  @apply opacity-0;
}

.uploadTitle {
  @apply text-emphasis-medium;
  @apply text-base;
  @apply font-semibold;
}

.uploadDescription {
  @apply text-emphasis-medium;
  @apply text-base;
  @apply font-normal;
}

.uploadDescription.smallDescription {
  @apply text-sm;
  @apply mb-4;
}
